import React, { useEffect, useState } from "react";
import TeamHeader from "../TeamHeader/TeamHeader";
import "./ToolsAndRepos.css";

// Icons
import { FaPlus } from "react-icons/fa6";
import { FaGithub } from "react-icons/fa";
import { SiNotion } from "react-icons/si";
import { MdDashboard } from "react-icons/md";
import { PiListPlusFill } from "react-icons/pi";

// Images
import plotbin1 from './Assets/plotbin-img1.png'
import plotbin2 from './Assets/plotbin-img2.png'
import toadash1 from './Assets/toa-dash-img2.png'
import toadash2 from './Assets/toa-dash-img3.png'

interface GitInfo {
    repo: string;
    branch: string;
    author: string;
    sha: string;
    message: string;
    date: string;
    url: string;
}

const formatUSDate = (isoDate: string) => {
    return new Date(isoDate).toLocaleString("en-US", {
        timeZone: "UTC",
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
};

// Creating Array that contain fetched Git information + Notion Link
const repos = [
    {
        name: "Peak Detector",
        repo: "detector-fw",
        branch: "master",
        notion: "https://www.notion.so/Peak-Cluster-68c69ff7e6db43a0a93f8043ecd87a84",
    },
    {
        name: "LCC",
        repo: "LCC",
        branch: "main",
        notion: "https://www.notion.so/LCC-Detector-905d1694a33d4fafae17f02a4369ebcc",
    },
    {
        name: "Cluster",
        repo: "PostProcess",
        branch: "main",
        notion: "https://www.notion.so/CLUSTER-documentation-4014c9b947f648c59baabc0e9047f568",
    },
    {
        name: "Monte Carlo",
        repo: "Lightning_MonteCarlo",
        branch: "main",
        notion: "https://www.notion.so/FNN-Monte-Carlo-5b41a52f3404433cbee4c064a78d49d8",
    },
    { name: "Efficiency (Server)", repo: "FNNEff", branch: "main", notion: null },
];

const ToolsAndRepos = () => {
    const [gitInfo, setGitInfo] = useState<Record<string, GitInfo | null>>({});
    const [loading, setLoading] = useState(true);

    // Popup on how to add more Repos
    const [showAddServerPopup, setShowAddServerPopup] = useState(false);

    useEffect(() => {
        const fetchAllRepos = async () => {
            const results: Record<string, GitInfo | null> = {};

            await Promise.all(
                repos.map(async ({ name, repo, branch }) => {
                    try {
                        const res = await fetch(
                            `/api/tools/github/latest-commit?repo=${repo}&branch=${branch}`,
                            { credentials: "same-origin" }
                        );
                        const data = await res.json();
                        results[name] = data;
                    } catch (err) {
                        console.error(`Error fetching ${repo}:`, err);
                        results[name] = null;
                    }
                })
            );

            setGitInfo(results);
            setLoading(false);
        };

        fetchAllRepos();
    }, []);

    return (
        <div className="customer-directory-body">
            <TeamHeader title="TOA" />

            <div className="customer-title-and-expand-buttons">
                <h1 className="cutomer-title">Tools & Repositories</h1>

                <div className="ai-expand-buttons">
                    <button className="general-sort-summary"
                        onClick={() => {
                            setShowAddServerPopup(true);
                        }}>
                        <FaPlus style={{ marginRight: "0.25rem", fontSize: "0.9rem" }} />{" "}
                        Entry
                    </button>
                </div>
            </div>

            {/* Repository Grid */}
            <h2 className="toa-rep-title">Repositories</h2>
            <div className="toa-repos-grid">
                {repos.map(({ name, notion }) => {
                    const info = gitInfo[name];
                    return (
                        <div key={name} className="toa-repo">
                            <h2>{name}</h2>

                            {loading && <span className="toa-git-muted">Loading...</span>}

                            {!loading && info && (
                                <div className="toa-git-info">
                                    <div className="toa-git-row">
                                        <span>Branch:</span> {info.branch}
                                    </div>
                                    <div className="toa-git-row">
                                        <span>Author:</span> {info.author}
                                    </div>
                                    <div className="toa-git-row">
                                        <span>Commit:</span> {info.sha}
                                    </div>
                                    <div className="toa-git-row">
                                        <span>Date (UTC):</span> {formatUSDate(info.date)}
                                    </div>

                                    <div className="toa-git-message">{info.message}</div>
                                    <a
                                        href={info.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="toa-git-link"
                                    >
                                        <FaGithub /> <p> GitHub Link</p>
                                    </a>
                                </div>
                            )}

                            {notion && (
                                <div className="toa-notion-section">
                                    <a
                                        href={notion}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="toa-git-link"
                                    >
                                        <SiNotion /> <p>Notion Link</p>
                                    </a>
                                </div>
                            )}

                            {!loading && !info && (
                                <span className="toa-git-muted">Failed to fetch info</span>
                            )}
                        </div>
                    );
                })}
            </div>

            {/* Tool Grid */}
            <h2 className="toa-rep-title">Tools</h2>
            <div className="toa-repos-grid">

                {/* Plot Bin */}
                <div className="toa-repo" style={{ height: 'fit-content' }}>
                    <h2>FNNplotbin</h2>
                    <div className="toa-notion-section">

                        <a
                            href="https://github.com/fire-neural-network/plot-bin"
                            target="_blank"
                            rel="noreferrer"
                            className="toa-git-link"
                        >
                            <FaGithub /> <p> GitHub Link</p>
                        </a>

                        <a
                            href="https://www.notion.so/FNN-bin-plot-executable-exe-d6e31690738b40c4885298de6532cf94"
                            target="_blank"
                            rel="noreferrer"
                            className="toa-git-link"
                        >
                            <SiNotion /> <p>Notion Link</p>
                        </a>

                        {/* Plotbin Images */}
                        <div className="toa-tools-imgs">
                            <img src={plotbin1} alt="plotbin-img1" ></img>
                            <img src={plotbin2} alt="plotbin-img2" ></img>
                        </div>
                    </div>
                </div>

                {/* TOA Dashboard */}
                <div className="toa-repo" style={{ height: 'fit-content' }}>
                    <h2>TOA Dashboard</h2>
                    <div className="toa-notion-section">

                        <a
                            href="https://fnnefficiency.streamlit.app/"
                            target="_blank"
                            rel="noreferrer"
                            className="toa-git-link"
                        >
                            <MdDashboard /> <p> Dashboard Link</p>
                        </a>

                        <a
                            href="https://www.notion.so/FNN-Detector-Efficiency-37fb0e9e946a4c9cb39d45a11db967e6?source=copy_link"
                            target="_blank"
                            rel="noreferrer"
                            className="toa-git-link"
                        >
                            <SiNotion /> <p>Notion Link</p>
                        </a>

                        {/* TOA Dashboard Images */}
                        <div className="toa-tools-imgs">
                            <img src={toadash1} alt="toadash-img1" ></img>
                            <img src={toadash2} alt="toadash-img2" ></img>
                        </div>
                    </div>
                </div>
            </div>

            {/* Popup Section */}
            {showAddServerPopup && (
                <div className='add-item-popup-overlay'>
                    <div className='add-item-popup-content hh-del-pop'>
                        <div className='hh-delete-inner-pop' style={{ gap: '2rem' }}>
                            <div className='hh-delete-text-and-icon'>

                                <PiListPlusFill className="ss-git-icon" />

                                <div>
                                    <h3>Instructions to Include More Repositories</h3>
                                    <p>
                                        Contact the website team and provide them with the GitHub and Notion&apos;s links.
                                        You will be informed once your new repository becomes visible in this page.
                                    </p>
                                </div>

                            </div>

                            <div className="hh-duo hh-actions">
                                <button
                                    className="cancel-btn"
                                    onClick={() => {
                                        setShowAddServerPopup(false);
                                    }}
                                >
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default ToolsAndRepos;
